<div class="csw-shell">
  <app-widget-header
    [title]="statsTypeEnum.stars | translate"
    [totalValue]="totalValue"
    [isDateTypeFilter]="true"
    [selectedDateFilterValue]="selectedDateFilterValue"
    [dateFilterOptions]="dateFilterOptions"
    (onDateFilterChange)="onDateFilterChange($event)"
  ></app-widget-header>

  <div class="csw-body">
    <div *ngIf="!chartMultiResult" class="csw-state">
      <span class="csw-state__dot"></span>
      <span class="csw-state__text">{{ 'GENERAL.LOADING' | translate }}…</span>
    </div>

    <div *ngIf="chartMultiResult && !chartMultiResult.length" class="csw-state">
      <i class="bi bi-bar-chart csw-state__icon"></i>
      <span class="csw-state__text">{{ 'WIDGET.NO_STATISTICS' | translate }}</span>
    </div>

    <div class="csw-chart" [ngClass]="'bar' + chartMultiResult?.length" *ngIf="chartMultiResult?.length">
      <ngx-charts-bar-vertical-stacked
        [scheme]="colorScheme"
        [results]="chartMultiResult"
        [xAxis]="true"
        [yAxis]="true"
        [legend]="true"
        [gradient]="true"
      ></ngx-charts-bar-vertical-stacked>
    </div>
  </div>
</div>
